module.exports = __webpack_public_path__ + "img/rhDSPicon.4f04a66b.svg";